import * as React from "react"
// import Logo from '@/components/MIT/Logo/Logo';
import { Box, Container } from "@mui/material"
import PasswordResetForm from "../features/auth/components/PasswordResetForm";
import Link from "@mui/material/Link";

export default function PasswordReset() {

  return (
    <>

        <title>Reset password</title>


      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Container maxWidth="xs">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component="img"
              sx={{
                display: "flex",
                height: 80,
                mb: 4,
              }}
              src="/logo152.png"
            />
          </div>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Box sx={{ mt: 1, minWidth: 360, p: 2 }}>
                <PasswordResetForm />
              </Box>
            </Box>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
            <Link href="/login">
                Terug naar login
            </Link>
          </div>
        </Container>
      </Box>
    </>
  )
}
